// extracted by mini-css-extract-plugin
export default {"container":"lastvideo_container__U76TJ","title":"lastvideo_title__-W4XE","titleSection":"lastvideo_titleSection__ZeA2h","button":"lastvideo_button__t62Se"};